import { General } from '../StrokeIcons';
import Avatar, { type AvatarProps } from './Avatar';

export type OrgAvatarProps = Omit<AvatarProps, 'srcs' | 'alt'> & {
  name?: string | null;
  src?: string | null;
};

/** Simple org avatar - takes name and src directly */
export function OrgAvatar({ name, src, ...props }: OrgAvatarProps) {
  return (
    <Avatar
      srcs={src ? [src] : []}
      alt={name ?? ''}
      placeholder={<General.Building07 />}
      {...props}
    />
  );
}
